export enum ButtonV2Size {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export enum ButtonV2Variant {
  Primary = 'primary',
  Secondary = 'secondary',
  Line = 'line',
  Negative = 'negative',
  Static = 'static',
}
